import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCircle, FaShieldAlt, FaTools, FaCheckCircle, FaNetworkWired } from "react-icons/fa";
import Chart from "react-apexcharts";

const DefenderScanDetail = ({ isSidebarOpen }) => {
  const [connectedAccounts, setConnectedAccounts] = useState([]);
  useEffect(() => {
      // Retrieve connected accounts from localStorage
      const accounts = localStorage.getItem("connectedAccounts");
      setConnectedAccounts(accounts ? JSON.parse(accounts) : []);
    }, []);
  const threatLevelChartOptions = {
    chart: { type: "radialBar" },
    plotOptions: {
      radialBar: {
        dataLabels: {
          total: {
            show: true,
            label: "Critical",
            color: "#6D5BFF",
            formatter: function () {
              return "50%";
            },
          },
        },
      },
    },
    labels: ["High", "Medium", "Low"],
    colors: ["#ff9800", "#4caf50", "#2196f3"],
  };

  const threatLevelChartSeries = [30, 15, 5];

  const issueChartOptions = {
    chart: { type: "line" },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
    },
    colors: ["#f44336", "#ff9800", "#4caf50"],
    markers: {
      size: 5,
    },
  };

  const issueChartSeries = [
    { name: "Critical", data: [50, 40, 35, 30] },
    { name: "High", data: [30, 25, 20, 15] },
    { name: "Medium", data: [20, 15, 10, 5] },
  ];

  const resourceChartOptions = {
    chart: { type: "bar" },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    colors: ["#4caf50", "#4caf50", "#ff9800", "#f44336"],
    xaxis: {
      categories: ["Engineering", "Support", "Marketing", "Sales"],
    },
  };

  const resourceChartSeries = [
    {
      name: "Allocation",
      data: [70, 60, 50, 40],
    },
  ];

  const activityLogs = [
    { id: 1, icon: <FaShieldAlt />, message: "New Service Scan", issues: 100, time: "2024-12-19 14:00" },
    { id: 2, icon: <FaTools />, message: "Updated Security Rules", issues: 80, time: "2024-12-19 13:30" },
    { id: 3, icon: <FaNetworkWired />, message: "Performed Vulnerability Scan", issues: 60, time: "2024-12-19 13:00" },
    { id: 4, icon: <FaCheckCircle />, message: "Scheduled Maintenance", issues: 40, time: "2024-12-19 12:30" },
    { id: 5, icon: <FaCircle />, message: "Network Audit Completed", issues: 20, time: "2024-12-19 12:00" },
  ];

  const detailedTableData = [
    { id: 1, type: "Critical", progress: "90%", completed: 45, errors: 5 },
    { id: 2, type: "High", progress: "75%", completed: 30, errors: 10 },
    { id: 3, type: "Medium", progress: "60%", completed: 20, errors: 15 },
    { id: 4, type: "Low", progress: "50%", completed: 10, errors: 20 },
  ];

  const additionalTableData = [
    { id: 1, name: "Task A", status: "Completed", priority: "High", assignedTo: "John Doe" },
    { id: 2, name: "Task B", status: "In Progress", priority: "Medium", assignedTo: "Jane Smith" },
    { id: 3, name: "Task C", status: "Pending", priority: "Low", assignedTo: "Alice Brown" },
    { id: 4, name: "Task D", status: "Completed", priority: "High", assignedTo: "Bob White" },
    { id: 5, name: "Task E", status: "Pending", priority: "Medium", assignedTo: "Charlie Black" },
    { id: 6, name: "Task F", status: "In Progress", priority: "High", assignedTo: "Diana Green" },
  ];
  if (!connectedAccounts || connectedAccounts.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center vh-100"
        style={{
          backgroundImage: 'url("/images/blurred_image.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="text-center text-dark p-4"
          style={{ backgroundColor: "rgba(170, 172, 242, 0.33)", borderRadius: "8px" }}
        >
          <h3>No Connected Accounts Found</h3>
          <p>
            To access this dashboard, please connect at least one account.
            Click the button below to get started.
          </p>
          <button className="btn text-white mt-3" style={{backgroundColor : '#342ead'}}
            onClick={() => window.location.href = "/dashboard/connected-accounts"}
          >
            Connect Account
          </button>
        </div>
      </div>
    );
  }
  return (
    <div
      className="cloudmap-page container-fluid"
      style={{
        marginLeft: isSidebarOpen ? "0px" : "0px",
        transition: "margin-left 0.3s ease",
      }}
    >
      <div className="container">
        
      <h3 className="fw-bold text-muted mb-4 ms-2" style={{ fontSize: "2rem", color: "#333" }}>Defender Scan Detail</h3>

        {/* Top Section */}
        <div className="row mb-4 g-3">
          {/* Threat Level */}
          <div className="col-md-8">
            <div className="row g-3">
              <div className="col-md-6">
                <div className="p-3 rounded shadow">
                  <div className="card-body">
                  <h5 className="fw-bold text-muted mb-1" style={{ color: "#333" }}>Threat Level</h5>
                    <Chart
                      options={threatLevelChartOptions}
                      series={[50, 30, 15]}
                      type="radialBar"
                      height={240}
                    />
                    <p className="text-center">Critical threats make up <span style={{color:"#6D5BFF"}}> 50% </span>of the total.</p>
                  </div>
                </div>
              </div>

              {/* Issues Chart */}
              <div className="col-md-6">
                <div className="p-3 rounded shadow">
                  <div className="card-body">
                  <h5 className="fw-bold text-muted mb-4" style={{ color: "#333" }}>Issues Over Time</h5>
                    <Chart
                      options={issueChartOptions}
                      series={issueChartSeries}
                      type="line"
                      height={250}
                    />
                  </div>
                </div>
              </div>
              {/* Detailed Logs Table */}
              <div className="col-md-12 mt-5">
                <div className="p-3 rounded shadow">
                  <div className="card-body">
                  <h5 className="fw-bold text-muted mb-4" style={{ color: "#333" }}>Detailed Logs</h5>
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="text-muted py-3">Type</th>
                          <th className="text-muted py-3">Progress</th>
                          <th className="text-muted py-3">Completed</th>
                          <th className="text-muted py-3">Errors</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detailedTableData.map((row) => (
                          <tr key={row.id}>
                            <td>{row.type}</td>
                            <td>
                              <div className="progress">
                              <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{
                                    width: row.progress,
                                    backgroundColor:
                                      row.type === "Critical"
                                        ? "#f44336" // Red for Critical
                                        : row.type === "High"
                                        ? "#ff9800" // Orange for High
                                        : row.type === "Medium"
                                        ? "#4caf50" // Green for Medium
                                        : "#2196f3", // Blue for Info
                                    color: "#fff", // Ensure text inside the progress bar is white
                                  }}
                                  aria-valuenow={parseInt(row.progress)}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {row.progress}
                                </div>
                              </div>
                            </td>
                            <td>{row.completed}</td>
                            <td>{row.errors}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          

          {/* Activity Logs */}
          <div className="col-md-4">
            <div className="p-3 rounded shadow">
              <div className="card-body">
              <h5 className="fw-bold text-muted mb-4" style={{ color: "#333" }}>Activity Logs</h5>
                <div className="timeline position-relative" style={{ paddingLeft: "20px" }}>
                  <div
                    className="position-absolute"
                    style={{ width: "2px", height: "100%", left: "34px", top: "0",backgroundColor:"#6D5BFF" }}
                  ></div>
                  {activityLogs.map((log, index) => (
                    <div key={log.id} className="timeline-item d-flex mb-4 align-items-start">
                      <div
                        className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                        style={{ width: "30px", height: "30px", zIndex: "1", position: "relative", border:"2px solid #6D5BFF", color:"#6D5BFF" }}
                      >
                        {log.icon}
                      </div>
                      <div className="ms-3">
                        <h6 className="fw-bold mb-1 text-muted">{log.message}</h6>
                        <small className="text-muted">{log.time}</small>
                        <p className="mb-0 mt-2 text-muted">
                          Issues Found: <span className="badge" style={{backgroundColor:"#666BFF54", color:"#6D5BFF"}}>{log.issues}</span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Middle Section */}
        <div className="row g-4">
          {/* Resource Distribution */}
          <div className="col-md-6">
            <div className="p-3 rounded shadow">
              <div className="card-body">
              <h5 className="fw-bold text-muted mb-1" style={{ color: "#333" }}>Resource Distribution</h5>
                <Chart
                  options={resourceChartOptions}
                  series={resourceChartSeries}
                  type="bar"
                  height={300}
                />
              </div>
            </div>
          </div>
          {/* Additional Table Section */}
          <div className="col-md-6 mb-4">
            <div className="Additional-Table-Section p-3 rounded shadow">
              <div className="card-body">
                <h5 className="fw-bold text-muted mb-3" style={{ color: "#333" }}>
                  Task Overview
                </h5>
                <div className="table-responsive" style={{ maxWidth: "100%" }}>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th className="text-muted">Task Name</th>
                        <th className="text-muted">Status</th>
                        <th className="text-muted">Priority</th>
                        <th className="text-muted">Assigned To</th>
                      </tr>
                    </thead>
                    <tbody>
                      {additionalTableData.map((task) => (
                        <tr key={task.id}>
                          <td>{task.name}</td>
                          <td>{task.status}</td>
                          <td>{task.priority}</td>
                          <td>{task.assignedTo}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefenderScanDetail;
